module.exports = __webpack_public_path__ + "static/media/ic_categories_2nd_hand.6db93a05.svg";